import { useEffect, useRef } from "react";
import { AppDOM } from "utils/app.utils";
import { Nullable } from "utils/typeCheck.utils";

export const useResize = (callback: Nullable<() => void>): void => {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    const container = AppDOM.appContainer;
    if (!container) return;

    const observer = new ResizeObserver(() => {
      callbackRef.current?.();
    });

    observer.observe(container);

    // Cleanup observer on unmount
    return () => observer.disconnect();
  }, []);
};
